// не забудьте сделать импорт внутри проекта
// @use '@devhacker/shared/utils/dom/scrollLock' as *;

export function lockScroll() {
  if (import.meta.server) {
    console.warn('lockScroll can be used only on client-side');
    return;
  }
  document.documentElement.classList.add('no-scroll');
}

export function unlockScroll() {
  if (import.meta.server) {
    console.warn('unlockScroll can be used only on client-side');
    return;
  }
  document.documentElement.classList.remove('no-scroll');
}
